import * as Yup from "yup";

const charRegex = /^(?=.*[a-zA-Z_])[a-zA-Z0-9_\s]+$/;
export const updateValidationSchema = Yup.object({
  Cat_ID: Yup.string()
    .trim()
    .required("Default Category is required")
    .max(25, "Maximum 25 characters allowed"),
  Default_Cat_Name: Yup.string()
    .trim()
    .required("Default Category is required")
    .max(25, "Maximum 25 characters allowed"),
  Cat_Value: Yup.string()
    .trim()
    .required("Subcategory is required")
    .matches(
      charRegex,
      "Subcategory must contain at least one letter and can include numbers and spaces"
    )
    .max(25, "Maximum 25 characters allowed"),
  Sub_Cat_Desc: Yup.string()
    .trim()
    .required("Description is required")
    .max(255, "Maximum 255 characters allowed"),
  //reschedule
});

export const updateInitialValues = {
  Cat_ID: "",
  Cat_Value: "",
  Cat_Desc: "",
  Default_Cat_Name: "",
};

export const MAX_CHARACTER_LENGTH = 250;
